import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../components/layout";

const DashboardContainer = () => {
  return (
    <div className="w-full flex h-[100vh]">
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
};

export default DashboardContainer;
